var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.total)?_c('div',{staticClass:"infoTop"},[_vm._v(" 合计开票金额："+_vm._s(_vm.total.toLocaleString('en-US', { minimumFractionDigits: 2}))+"元 ")]):_vm._e(),_c('TableWithPagination',{attrs:{"max-height":"400px","tableData":_vm.targetLists,"columnList":_vm.columnList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }